import React from 'react'
import Header from '../components/Header'
import Classes from '../components/Classes'

export default function ClassesPage() {
  return (
    <div>
        <Header title={'Classes'} />
        <Classes />
    </div>
  )
}
